import axiosHttp from "./interceptor";
import { emitToasterMsg } from "./toasterUtility";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const callApi = async ({ url, method = "Get", data = {}, headers = {}, responseType="" }) => {
    try {
        const response = await axiosHttp({
            url,
            method,
            data,
            headers,
            responseType
        });
        return response?.data;
    } catch (error) {
        throw error?.response?.data;
    }
};

export const useMonitoringPlanActions = () => {
    const deleteMonitoringPlan = async (vesselMstId) => {
        try {
            const response = await callApi({
                url: `${BASE_URL}api/MrvMonitoringPlan/DeleteMonitoringPlanAsync?vesselMstId=${vesselMstId}`,
                method: "DELETE",
            });

            if (response?.isSuccess) {
                emitToasterMsg("success", "MRV Monitoring Plan", "Deleted Successfully");
            } else {
                emitToasterMsg("error", "MRV Monitoring Plan", response?.errorMessage || "Delete failed");
            }
        } catch (error) {
            console.error("MRV Delete Error:", error);
            emitToasterMsg("error", "MRV Monitoring Plan", error?.errorMessage || "Delete failed");
        }
    };

    const deleteFuelEuMonitoringPlan = async (vesselMstId) => {
        try {
            const response = await callApi({
                url: `${BASE_URL}api/FuelEuMonitoringPlan/DeleteMonitoringPlanAsync?vesselMstId=${vesselMstId}`,
                method: "DELETE",
            });

            if (response?.isSuccess) {
                emitToasterMsg("success", "FuelEU Monitoring Plan", "Deleted Successfully");
            } else {
                emitToasterMsg("error", "FuelEU Monitoring Plan", response?.errorMessage || "Delete failed");
            }
        } catch (error) {
            console.error("FuelEU Delete Error:", error);
            emitToasterMsg("error", "FuelEU Monitoring Plan", error?.errorMessage || "Delete failed");
        }
    };

    return {
        deleteMonitoringPlan, // for MRV
        deleteFuelEuMonitoringPlan, // for FuelEU
    };
};

//getVesselDetails  by vesselId oncreate 
export const getVesselById = async (vesselMstId) => {
    try {
        const res = await callApi({
            url: `api/MyFleet/GetVesselById?vesselMstId=${vesselMstId}`,
            method: "GET",
        });
        if (!res?.Data) {
            throw new Error("No vessel data returned.");
        }
        return res.Data;
    } catch (err) {
        emitToasterMsg(
            "error",
            "Vessel Details",
            err?.errorMessage || err.message || "Could not fetch vessel details"
        );
        throw err;
    }
};

//using this flags api in multiple components
export const getMonitoringPlanFlags = async (vesselMstId) => {
    try {
        const res = await callApi({
            url: `${BASE_URL}api/MrvMonitoringPlan/flags/${vesselMstId}`,
            method: "GET",
        });

        return res;
    } catch (err) {
        console.error("API Error (flags):", err);
        emitToasterMsg(
            "error",
            "Monitoring Plan",
            err?.errorMessage || err.message || "Could not fetch plan flags"
        );
        throw err;
    }
};